const referrer = ['https://www.amio-ads.ru/', 'https://amio-ads.ru/']
export function setReferrer(){
  if(referrer.includes(document.referrer)){
    window.sessionStorage.setItem('referrer', document.referrer)
  }
}

export function isReferrer(){
  return referrer.includes(window.sessionStorage.getItem('referrer'))
}